import React from "react";
import AgentsAdminLayout from "../../template/admin.layout";
import FixedScrollSectionTemplate from "../../components/fixed-scroll-section";
import PanelLoading from "../../../../../components/panel/panel.loading";
import SponsorCreateForm from "./sponsor-create-form/sponsor-create-form";

const SponsorCreatePage = () => {
  return (
    <AgentsAdminLayout>
      <div className="mt-32 h-full w-full pb-32">
        <FixedScrollSectionTemplate classname="h-full">
          <div className="my-6 flex flex-grow flex-col items-center justify-center">
            <div className="w-full md:w-3/4">
              <PanelLoading title={"Crear nuevo sponsor"} isLoading={false}>
                <SponsorCreateForm />
              </PanelLoading>
            </div>
          </div>
        </FixedScrollSectionTemplate>
      </div>
    </AgentsAdminLayout>
  );
};

export default SponsorCreatePage;
